import { CHANGE_USER_EMAIL_REQUEST, CHANGE_USER_EMAIL_SUCCESS, CHANGE_USER_EMAIL_FAILURE } from '../../constants/user_emails.constants';

export const changeUserEmailRequest = (name, email, user_id, email_id) => ({
    type: CHANGE_USER_EMAIL_REQUEST, name, email, user_id, email_id,
});
export const changeUserEmailRequestSuccess = payload => ({ type: CHANGE_USER_EMAIL_SUCCESS, payload });
export const changeUserEmailRequestFailure = error => ({ type: CHANGE_USER_EMAIL_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_emails_actions/change_user_email.actions.js